// global site variables

const detectReducedMotionPref = window.matchMedia('(prefers-reduced-motion: reduce)');

export const siteSettings = {
    reducedMotionPref: detectReducedMotionPref.matches
}

export const viewport = {
    vw: 0,
    vh: 0,
    setVw: (val) => {
        viewport.vw = val;
    },
    setVh: (val) => {
        viewport.vh = val;
    }
}

export const mainNavigation = {
    mobileActive: false,
    setMobileActive: (mode) => {
        mainNavigation.mobileActive = mode;
    },
    desktopActive: false,
    setDesktopActive: (mode) => {
        mainNavigation.desktopActive = mode;
    }
};

export const headerSearch = {
    active: false,
    setActive: (mode) => {
        headerSearch.active = mode;
    }
};